import React, {Component} from 'react';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormGroup from '@material-ui/core/FormGroup';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import grey from '@material-ui/core/colors/grey';
import lightBlue from '@material-ui/core/colors/lightBlue';
import CheckBoxOutlineBlank from "@material-ui/core/es/internal/svg-icons/CheckBoxOutlineBlank";
import CheckBox from "@material-ui/core/es/internal/svg-icons/CheckBox";

const styles = {
	root: {
		color: grey[400],
		'&$checked': {
			color: lightBlue[600],
		},
	},
	checked: {},
	label: {
		color: '#666',
		fontSize: 16,
		fontFamily: "futura-pt, sans-serif",
		marginBottom: 3,
		textTransform: 'uppercase'
	},
	checkboxIcons: {
		fontSize: 30
	}
};

class ContactFormCheckbox extends Component {
	constructor(props) {
		super(props);
		this.state = {
			isInProgress: true
		}
	}

	render() {
		const {classes} = this.props;
		return (
			<FormGroup>
				<FormControlLabel classes={{label: classes.label}} control={
					<Checkbox type={this.props.type} id={this.props.id}
					          name={this.props.name}
					          value={this.props.value}
					          checkedIcon={<CheckBox className={classes.checkboxIcons} />}
					          icon={<CheckBoxOutlineBlank className={classes.checkboxIcons}/>}
					          classes={{
						          root: classes.root,
						          checked: classes.checked,
					          }}/>
				} label={this.props.value}/>
			</FormGroup>
		)
	}
}

ContactFormCheckbox.propTypes = {
	classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(ContactFormCheckbox);

